// EXPLAIN: the reason use date-fns: https://github.com/Hacker0x01/react-datepicker/issues/1658
import cn from "date-fns/locale/zh-CN";
import moment from 'moment';
import { forwardRef, useEffect, useState } from "react";
import { Button, Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getXXXW, getXXXWAllowedDate } from "../../../api/xxxwApi";
import { dispatchAlertError } from "../../../app/godispatch";
import Loading from "../../component/Loading";
import RoleLayout from "../../component/RoleLayout";
import WaterMark from "../../component/WaterMark";
import './XXXWPage.css';

export default function XXXWPage() {
    document.title = '行为风水-星宿'
    const [startDate, setStartDate] = useState();
    const [maxDate, setMaxDate] = useState(null);
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <Button variant="outline-info" className="choosedate" onClick={onClick} ref={ref} disabled={loading}>
            {value ? value : '请点击选择'}
        </Button>
    ));
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState()

    useEffect(() => {
        getXXXWAllowedDate()
            .then((res) => {
                setMaxDate(moment(res.data).toDate())
            })
            .catch((err) => {
            })
    }, [])

    useEffect(() => {
        if (startDate) {
            setLoading(true)
            let param = moment(startDate).format('YYYY-MM-DD HH:mm:ss')
            getXXXW(param)
                .then((res) => {
                    setData([...res.data.look1, ...res.data.look2])
                    setLoading(false)
                })
                .catch((err) => {
                    dispatchAlertError(err.message || '查询失败请稍后再试')
                    setData('')
                    setLoading(false)
                })
        }
    }, [startDate])

    return (
        <RoleLayout>
            <WaterMark>
                <Container className="xxxwBackground">
                    <Row className='divide'></Row>
                    <Row >
                        <Col></Col>
                        <Col sm={8} md={6} className='d-flex justify-content-center align-items-center'>
                            <Form.Label className="fs-4 choosedatename "><strong>查询日期时间(阳历)</strong></Form.Label>
                            <DatePicker selected={startDate}
                                showTimeSelect
                                onChange={(date) => setStartDate(date)}
                                minDate={moment().toDate()}
                                maxDate={maxDate}
                                selectsStart
                                dateFormat="yyyy-MM-dd HH:mm"
                                locale={cn}
                                customInput={<ExampleCustomInput />}
                            />
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row>
                        <Col className='d-flex justify-content-center align-items-center'>
                            <strong style={{ color: 'red' }}></strong>
                        </Col>
                    </Row>
                    <Row className='divide'></Row>
                    {loading && <Loading />}
                    {!loading && data &&
                        <>
                            <Row className="xxxwResultBlock">
                                <Col className='d-flex justify-content-center align-items-center'>
                                    出门前看
                                </Col>
                            </Row>
                            {data.map(item => (
                                <Row className="xxxwResultBlock">
                                    <Col className='d-flex justify-content-center align-items-center'>
                                        {item}的图片
                                    </Col>
                                </Row>
                            ))}
                        </>
                    }
                </Container >
            </WaterMark>
        </RoleLayout >
    )
}